import { render, staticRenderFns } from "./ManagerGroupsTicketsPage.vue?vue&type=template&id=519fbaba"
import script from "./ManagerGroupsTicketsPage.vue?vue&type=script&lang=js"
export * from "./ManagerGroupsTicketsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports